import { render } from "./BeforeDeliveryOrders.vue?vue&type=template&id=4ed02865"
import script from "./BeforeDeliveryOrders.vue?vue&type=script&lang=js"
export * from "./BeforeDeliveryOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__